import { css } from '@emotion/react';
import { Button } from 'components/Button';
import { FormControl } from 'components/FormControl';
import { FormFooter } from 'components/FormFooter';
import { FormLine } from 'components/FormLine';
import { Input } from 'components/Input';
import { useUpdatePasswordMutation } from 'generated/graphql';
import { useStore } from 'hooks/useStore';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

enum FORM_ACCOUNT_PASSWORD {
	OLD_PASSWORD = 'old_password',
	PASSWORD = 'password',
	CONFIRM_PASSWORD = 'password_confirmation',
}

export const AccountPasswordForm = () => {
	const {
		register,
		handleSubmit,
		formState: { errors },
		watch,
		reset,
	} = useForm();

	const [formError, setFormError] = useState(null);

	const { notifications } = useStore();

	const [updatePassword, executeUpdatePassword] = useUpdatePasswordMutation();
	const { fetching, error } = updatePassword;

	const onSubmit = (data) => {
		executeUpdatePassword({ input: data }).then((result) => {
			// TODO: POKUD JSOU ERRORS, TAK VYHODIT MESSAGE NAD FORMEM, ZE HESLO NESOUHLASI

			if (result.error) {
				if (result.error.graphQLErrors && result.error.graphQLErrors.length > 0) {
					setFormError(translateErrorMessages(result.error.graphQLErrors));
				}

				if (result.error.networkError) {
					// console.error('Network Error:', result.error.networkError);
					// alert('Network error: Unable to connect to the server.');
				}
			} else {
				if (result.data.updatePassword.status === 'PASSWORD_UPDATED') {
					notifications.addNotification({ title: '✅ Hotovo', message: 'Heslo bylo změněno.' });
					reset();
				}
			}
		});
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			{formError && (
				<div
					css={css`
						color: #ff6767;
						background: #fff0f0;
						border-radius: 12px;
						padding: 12px 20px;
						margin-bottom: 20px;
					`}
				>
					{formError.map((errors) => {
						return errors.map((error, key) => {
							return <div key={key}>{error}</div>;
						});
					})}
				</div>
			)}

			<FormLine first>
				<FormControl
					required
					label="Aktuální heslo"
					htmlFor={FORM_ACCOUNT_PASSWORD.OLD_PASSWORD}
					labelWidth={160}
					error={errors[FORM_ACCOUNT_PASSWORD.OLD_PASSWORD]}
				>
					<Input
						isPassword
						width={164}
						placeholder=""
						{...register(FORM_ACCOUNT_PASSWORD.OLD_PASSWORD, {
							required: 'Zadejte aktuální heslo.',
						})}
						error={!!errors[FORM_ACCOUNT_PASSWORD.OLD_PASSWORD]}
					/>
				</FormControl>
			</FormLine>

			<FormLine>
				<FormControl
					required
					label="Nové heslo"
					htmlFor={FORM_ACCOUNT_PASSWORD.PASSWORD}
					labelWidth={160}
					error={errors[FORM_ACCOUNT_PASSWORD.PASSWORD]}
				>
					<Input
						isPassword
						width={164}
						placeholder=""
						{...register(FORM_ACCOUNT_PASSWORD.PASSWORD, {
							required: 'Zadejte nové heslo.',
							minLength: { value: 8, message: 'Heslo musí obsahovat alespon 8 znaků.' },
						})}
						error={!!errors[FORM_ACCOUNT_PASSWORD.PASSWORD]}
					/>
				</FormControl>
			</FormLine>

			<FormLine>
				<FormControl
					required
					label="Potvrzení hesla"
					htmlFor={FORM_ACCOUNT_PASSWORD.CONFIRM_PASSWORD}
					labelWidth={160}
					error={errors[FORM_ACCOUNT_PASSWORD.CONFIRM_PASSWORD]}
				>
					<Input
						isPassword
						width={164}
						placeholder=""
						{...register(FORM_ACCOUNT_PASSWORD.CONFIRM_PASSWORD, {
							required: 'Pro potvrzení zadejte znovu nové heslo.',
							validate: (val: string) => {
								if (watch(FORM_ACCOUNT_PASSWORD.PASSWORD) !== val) {
									return 'Hesla se musí shodovat.';
								}
							},
						})}
						error={!!errors[FORM_ACCOUNT_PASSWORD.CONFIRM_PASSWORD]}
					/>
				</FormControl>
			</FormLine>

			<FormFooter>
				<Button isProcessing={fetching}>Změnit heslo</Button>
			</FormFooter>
		</form>
	);
};

// TODO: TOHLE POZDEJI DODELAT PORADNE

const translateErrorMessages = (graphQLErrors) => {
	// console.log(graphQLErrors);

	const errors = graphQLErrors.map((item) => {
		return Object.entries(item.extensions.errors).map(([field, message]) => {
			// Přeložíme zprávu, pokud existuje překlad, jinak použijeme originální zprávu
			const translatedMessage = errorTranslations[message] || message;
			return `${translatedMessage}`;
		});
	});

	return errors;
};

const errorTranslations = {
	'Current password is incorrect': 'Aktuální heslo je nesprávné.',
	'Password is too short': 'Heslo je příliš krátké.',
	'Password confirmation does not match': 'Potvrzení hesla se neshoduje.',
};
